// Base
import Image from 'next/image'

// Components
import { Container } from '@components/app/Layout'
import { Button } from '../button/Buttons'

// Styles
import styles from './Header.module.sass'

const Header = () => {
  return (
    <header className={styles.header}>
      <Container>
        <div className={styles.header__wrapper}>
          <div className={styles.header__logo}>
            <Image
              src="/images/icons/ratepunk-premium-logo.svg"
              width={108}
              height={36}
              alt="RatePunk Logo"
            />
          </div>

          <Button href="https://flights.ratepunk.com/" variant="button-2">
            Join Now
          </Button>
        </div>
      </Container>
    </header>
  )
}

export default Header
